import { FileText } from "lucide-react";

const QueryCard = ({ id, title, category, date }) => {
  return (
    <div className="bg-white rounded-md shadow-sm p-6 text-center hover:shadow-md transition">
      <div className="flex justify-center mb-4 text-[#1B3CD6]">
        <FileText size={32} />
      </div>

      <h3 className="font-medium text-xl">Query #{id}</h3>

      <p className="text-gray-500 mt-1">{category}</p>

      <p className="font-medium text-xl mt-4">{date}</p>
    </div>
  );
};

export default QueryCard;
